import { useState } from 'react'

import { api, ApiError } from '../../api/client'
import type { Trip } from '../../api/types'
import { useQueryClient } from '@tanstack/react-query'
import { keys } from '../../hooks/queries'
import { Blasenwahl, type Blasensatz } from '../settings/Blasenwahl'

/**
 * Die Farbe der Sprechblasen **in dieser Reise, nur für mich** (#52).
 *
 * Aus dem Betrieb: „Auch Mitlesende sollen die Farbe der Chatblasen einstellen
 * können (aber nicht den Hintergrund!). Voreinstellung ist die Einstellung des
 * Reisenden."
 *
 * **Der Hintergrund gehört dem Bericht, die Blase den Augen.** Deshalb steht
 * hier genau eine Karte und nicht die drei des Reisenden: ein Mitlesender
 * ändert nichts an dem, was die anderen sehen.
 *
 * **Leer heißt „wie der Reisende"** — die dritte Stufe der Kette
 * Voreinstellung → Reise → Leser. Der Knopf an jeder Zeile sagt es.
 */
export function MeineBlasenfarben({ trip }: { trip: Trip }) {
  const client = useQueryClient()
  const [laeuft, setLaeuft] = useState(false)
  const [gemeldet, setGemeldet] = useState(false)
  const [problem, setProblem] = useState<string | null>(null)

  const meine = trip.chat_bubbles_mine ?? { own: null, other: null }

  return (
    <div className="card card--seite">
      <h2 className="card__titel">Farbe der Sprechblasen</h2>
      <Blasenwahl
        lead="Nur für dich — die anderen sehen weiter, was der Reisende eingestellt hat."
        werte={{
          chat_own_color: meine.own ?? '',
          chat_other_color: meine.other ?? '',
        }}
        /* **Was das Farbfeld zeigt, solange hier nichts steht**: die Farbe des
           Reisenden. Aus dem Betrieb gemeldet -- dort stand die allgemeine
           Voreinstellung, und die gilt in dieser Reise gar nicht. */
        ererbt={{
          chat_own_color: trip.chat_bubbles?.own ?? '',
          chat_other_color: trip.chat_bubbles?.other ?? '',
        }}
        leerText="Wie der Reisende"
        laeuft={laeuft}
        fehler={problem}
        gemeldet={gemeldet}
        onSpeichern={async (satz: Blasensatz) => {
          setGemeldet(false)
          setProblem(null)
          setLaeuft(true)
          try {
            const neu = await api.post<Trip>(`/api/trips/${trip.id}/ansicht`, satz)
            client.setQueryData(keys.trip(trip.id), neu)
            setGemeldet(true)
          } catch (fehler) {
            setProblem(
              fehler instanceof ApiError && fehler.offline
                ? 'Dafür braucht es Netz. Versuch es später noch einmal.'
                : fehler instanceof Error
                  ? fehler.message
                  : 'Das hat nicht geklappt.',
            )
            throw fehler
          } finally {
            setLaeuft(false)
          }
        }}
      />
    </div>
  )
}
